export const ADD_ATTR = 'ADD_ATTR';

export const ADD_LIST_START = 'ADD_LIST_START';
export const ADD_LIST_SUCCESS = 'ADD_LIST_SUCCESS';
export const ADD_LIST_FAILURE = 'ADD_LIST_FAILURE';

export const ADD_LINE_START = 'ADD_LINE_START';
export const ADD_LINE_SUCCESS = 'ADD_LINE_SUCCESS';
export const ADD_LINE_FAILURE = 'ADD_LINE_FAILURE';

export const EDIT_LINE_START = 'EDIT_LINE_START';
export const EDIT_LINE_SUCCESS = 'EDIT_LINE_SUCCESS';
export const EDIT_LINE_FAILURE = 'EDIT_LINE_FAILURE';

export const FETCH_LINES_START = 'FETCH_LINES_START';
export const FETCH_LINES_SUCCESS = 'FETCH_LINES_SUCCESS';
export const FETCH_LINES_FAILURE = 'FETCH_LINES_FAILURE';

export const ADD_IMG_TO_LINE_START = 'ADD_IMG_TO_LINE_START';
export const ADD_IMG_TO_LINE_SUCCESS = 'ADD_IMG_TO_LINE_SUCCESS';
export const ADD_IMG_TO_LINE_FAILURE = 'ADD_IMG_TO_LINE_FAILURE';

export const FETCH_ADDED_LINE_SUCCESS = 'FETCH_ADDED_LINE_SUCCESS';

export const FETCH_TITLE_START = 'FETCH_TITLE_START';
export const FETCH_TITLE_SUCCESS = 'FETCH_TITLE_SUCCESS';
export const FETCH_TITLE_FAILURE = 'FETCH_TITLE_FAILURE';

export const FETCH_LINE_START = 'FETCH_LINE_START';
export const FETCH_LINE_SUCCESS = 'FETCH_LINE_SUCCESS';
export const FETCH_LINE_FAILURE = 'FETCH_LINE_FAILURE';

export const TOGGLE_SETTING_SUCCESS = 'TOGGLE_SETTING_SUCCESS';
export const TOGGLE_SHARE_SUCCESS = 'TOGGLE_SHARE_SUCCESS';
export const TOGGLE_LISTS_SUCCESS = 'TOGGLE_LISTS_SUCCESS';
export const TOGGLE_COMMENTS_SUCCESS = 'TOGGLE_COMMENTS_SUCCESS';
export const TOGGLE_LIST_HEADER_SUCCESS = 'TOGGLE_LIST_HEADER_SUCCESS';
export const TOGGLE_HISTORY_SUCCESS = 'TOGGLE_HISTORY_SUCCESS';

export const EDIT_TITLE_START = 'EDIT_TITLE_START';
export const EDIT_TITLE_SUCCESS = 'EDIT_TITLE_SUCCESS';
export const EDIT_TITLE_FAILURE = 'EDIT_TITLE_FAILURE';

export const ADD_TITLE_START = 'ADD_TITLE_START';
export const ADD_TITLE_SUCCESS = 'ADD_TITLE_SUCCESS';
export const ADD_TITLE_FAILURE = 'ADD_TITLE_FAILURE';

export const ADD_TAG_START = 'ADD_TAG_START';
export const ADD_TAG_SUCCESS = 'ADD_TAG_SUCCESS';
export const ADD_TAG_FAILURE = 'ADD_TAG_FAILURE';

export const FETCH_TAGS_START = 'FETCH_TAGS_START';
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';
export const FETCH_TAGS_FAILURE = 'FETCH_TAGS_FAILURE';

export const FETCH_TAG_COLORS_SUCCESS = 'FETCH_TAG_COLORS_SUCCESS';

export const OPEN_COMMENTS_SUCCESS = 'OPEN_COMMENTS_SUCCESS';
export const CLOSE_COMMENTS_SUCCESS = 'CLOSE_COMMENTS_SUCCESS';

export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
export const ADD_COMMENTS_SUCCSESS = 'ADD_COMMENTS_SUCCSESS';

export const ADD_NOTIFIC_COMMENTS_IDS_SUCCESS = 'ADD_NOTIFIC_COMMENTS_IDS_SUCCESS';
export const FETCH_NOTIFIC_COMMENTS_IDS_SUCCESS = 'FETCH_NOTIFIC_COMMENTS_IDS_SUCCESS';
export const REMOVE_NOTIFIC_COMMENTS_IDS_SUCCESS = 'REMOVE_NOTIFIC_COMMENTS_IDS_SUCCESS';

export const EDIT_FAVICON_SUCCESS = 'EDIT_FAVICON_SUCCESS';

export const EDIT_USER_NAME_START = 'EDIT_USER_NAME_START';
export const EDIT_USER_NAME_SUCCESS = 'EDIT_USER_NAME_SUCCESS';
export const EDIT_USER_NAME_FAILURE = 'EDIT_USER_NAME_FAILURE';

export const FETCH_USER_NAME_START = 'FETCH_USER_NAME_START';
export const FETCH_USER_NAME_SUCCESS = 'FETCH_USER_NAME_SUCCESS';
export const FETCH_USER_NAME_FAILURE = 'FETCH_USER_NAME_FAILURE';

export const FETCH_USER_START = 'FETCH_USER_START';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const EDIT_USER_START = 'EDIT_USER_START';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAILURE = 'EDIT_USER_FAILURE';

export const FETCH_HISTORY_START = 'FETCH_HISTORY_START';
export const FETCH_HISTORY_SUCCESS = 'FETCH_HISTORY_SUCCESS';
export const FETCH_HISTORY_FAILURE = 'FETCH_HISTORY_FAILURE';

export const ADD_HISTORY_START = 'ADD_HISTORY_START';
export const ADD_HISTORY_SUCCESS = 'ADD_HISTORY_SUCCESS';
export const ADD_HISTORY_FAILURE = 'ADD_HISTORY_FAILURE';

export const FETCH_FILTER_TAG_IDS_SUCCSESS = 'FETCH_FILTER_TAG_IDS_SUCCSESS';
export const EDIT_FILTER_TAG_IDS_SUCCSESS = 'EDIT_FILTER_TAG_IDS_SUCCSESS';

export const FETCH_COMMENTS_TIME_SUCCESS = 'FETCH_COMMENTS_TIME_SUCCESS';

export const FETCH_LINE_UPDATE_TIME_SUCCESS = 'FETCH_LINE_UPDATE_TIME_SUCCESS';

export const ADD_FILTER_TAG_IDS_SUCCESS = 'ADD_FILTER_TAG_IDS_SUCCESS';
export const FETCH_FILTER_TAG_IDS_SUCCESS = 'FETCH_FILTER_TAG_IDS_SUCCESS';
export const REMOVE_FILTER_TAG_IDS_SUCCESS = 'REMOVE_FILTER_TAG_IDS_SUCCESS';

export const SAVE_RANGY_SUCCESS = 'SAVE_RANGY_SUCCESS';

export const FETCH_SAVED_LISTS_SUCCESS = 'FETCH_SAVED_LISTS_SUCCESS';

export const ADD_SAVED_LISTS_NOTIFICATION_SUCCESS = 'ADD_SAVED_LISTS_NOTIFICATION_SUCCESS';
export const ADD_SAVED_LISTS_NOTIFICATION_START = 'ADD_SAVED_LISTS_NOTIFICATION_START';

export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS';
export const ADD_SETTINGS_SUCCESS = 'ADD_SETTINGS_SUCCESS';

export const ADD_KEY_LIST_SUCCESS = 'ADD_KEY_LIST_SUCCESS';




// WEBPACK FOOTER //
// ./src/actionTypes.js